<div id="control-screen" *ngIf="checkIDState === 1">
  <div class="donateshow" *ngIf="donateState === 3">
    <div id="youtube">
      <p *ngIf="isPlay" class="lefttime">{{videoTimeLeft}} Seconds Left....</p>
      <youtube-player [videoId]="yid" (ready)="savePlayer($event)" (change)="onStateChange($event)"
        [playerVars]="playerVars" id="ytplayer" >
      </youtube-player>
    </div>
  </div>

</div>
